import { ClientSide } from "~/@types";
import { IImageFields } from "~/@types/generated/contentful";
import { getTwicPicsURL } from "./getTwicPicsURL";

export const getImageURL = (imageField: ClientSide<IImageFields>) => {
  return getTwicPicsURL(imageField);
};
